import { jsxs as Y, jsx as b } from "react/jsx-runtime";
import { forwardRef as Z, useState as u, useCallback as s, useMemo as _, useEffect as k, Children as $, isValidElement as L } from "react";
import "../../icons/index.es.js";
import "../../atoms/Button/Button.es.js";
import "@chakra-ui/react";
import "../Dropdown/Dropdown.context.es.js";
import { DropdownItem as S } from "../Dropdown/components/DropdownItem.es.js";
import { Dropdown as tt } from "../Dropdown/Dropdown.container.es.js";
import { AutocompleteComponent as et } from "./Autocomplete.component.es.js";
import { AutocompleteInput as rt } from "./components/AutocompleteInput.es.js";
import "./components/AutocompleteOptions.es.js";
import { i as x } from "../../isEqual-24663bfb.js";
const ht = Z(
  ({
    ariaLabel: R,
    children: l,
    customActions: c = [],
    emptyStatePlaceholder: V,
    isDisabled: j,
    isError: q,
    isLoading: d,
    isSmartData: A,
    isTruncated: B = !0,
    leftAddon: F,
    maxHeight: M = !0,
    onBlur: h,
    onChange: n,
    onClear: C,
    onFocus: w,
    onRetry: O,
    onSelectOption: f,
    options: e = [],
    placeholder: Q,
    selectedOption: a,
    size: g,
    trackId: v,
    isSearchOnly: z = !1,
    value: G
  }, H) => {
    const [r, m] = u(a), [J, I] = u(!1), [y, i] = u(e), [K, N] = u(""), P = s((t) => {
      m(t), f == null || f(t, p);
    }, []), D = (t) => {
      let o = !1;
      return $.forEach(t, (E) => {
        L(E) && E.type === S && (o = !0);
      }), o;
    }, T = s(
      async (t) => {
        if (n) {
          const o = await n(t);
          o && i(o);
        }
        N(t);
      },
      [n, i]
    ), U = s((t) => {
      (D(l) || c.length > 0) && (I(!0), w && w(t));
    }, []), W = s((t) => {
      D(l) && h && h(t);
    }, []), X = z ? G : _(() => (r == null ? void 0 : r.label) ?? "", [r]), p = s(() => {
      m(void 0), C && C();
    }, [m]);
    return k(() => {
      e && !x(e, y) && i(e);
    }, [e]), k(() => {
      x(a, r) || m(a);
    }, [a]), /* @__PURE__ */ Y(
      tt,
      {
        disableInteractions: !0,
        isOpen: J,
        isTruncated: B,
        maxHeight: M,
        setIsOpen: I,
        children: [
          /* @__PURE__ */ b(
            rt,
            {
              ariaLabel: R,
              defaultValue: X,
              isDisabled: j,
              isError: q,
              isLoading: d,
              isSmartData: A,
              leftAddon: F,
              onBlur: W,
              onChange: T,
              onClear: p,
              onFocus: U,
              onRetry: O,
              placeholder: Q,
              ref: H,
              size: g,
              trackId: v
            }
          ),
          /* @__PURE__ */ b(
            et,
            {
              isLoading: d,
              customActions: c,
              onClickOption: P,
              onClear: p,
              options: y,
              query: K,
              emptyStatePlaceholder: V,
              children: l
            }
          )
        ]
      }
    );
  }
);
export {
  ht as Autocomplete
};
//# sourceMappingURL=Autocomplete.container.es.js.map
